import Dashboard from "./dashboard";

export default function Onboarding() {
    return (
        <Dashboard />
    )
}